var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-processo", attrs: { shadow: "hover" } },
    [
      _c(
        "el-row",
        { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c(
              "div",
              { staticClass: "pesquisa" },
              [
                !_vm.processo
                  ? _c(
                      "el-button",
                      {
                        staticClass: "botao-voltar",
                        attrs: { type: "primary" },
                        on: { click: _vm.voltar }
                      },
                      [
                        _c("span", { staticClass: "center" }, [
                          _c("i", { staticClass: "fas fa-chevron-left" })
                        ])
                      ]
                    )
                  : _vm._e(),
                _c("h1", { staticClass: "titulo" }, [
                  _vm._v(
                    _vm._s(
                      _vm.processo
                        ? "Processo encontrado"
                        : "Pesquisar Processo"
                    )
                  )
                ])
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
        [
          _c("el-col", { attrs: { span: 12 } }, [
            _c("h4", [_vm._v("Número do Processo:")]),
            _c(
              "div",
              { staticClass: "pesquisa" },
              [
                _c("el-input", {
                  staticClass: "input-with-select",
                  attrs: { placeholder: "N° do Processo" },
                  model: {
                    value: _vm.numProcesso,
                    callback: function($$v) {
                      _vm.numProcesso = $$v
                    },
                    expression: "numProcesso"
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "botao-limpar",
                    attrs: { id: "botao-limpar" },
                    on: { click: _vm.limpar }
                  },
                  [_c("span", [_vm._v("Limpar")])]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "color-default",
                    attrs: {
                      type: "primary",
                      icon: "el-icon-search",
                      id: "botao-pesquisar"
                    },
                    on: { click: _vm.pesquisar }
                  },
                  [_c("span", [_vm._v("Pesquisar")])]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("card-mover-processo", {
                attrs: { processo: _vm.processo, opcoesAcoes: true }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
        [
          _vm.processo
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("app-label", {
                    staticStyle: { "margin-top": "10px" },
                    attrs: {
                      label: "Selecione o setor que deseja mover o processo:"
                    }
                  }),
                  _c("h4", [_vm._v("Setor:")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "select input-with-select select",
                      attrs: {
                        placeholder: "Selecione a caixa",
                        disabled:
                          _vm.aguardandoDistribuicao || !!_vm.conversaAberta,
                        filterable: "filterable"
                      },
                      model: {
                        value: _vm.setor,
                        callback: function($$v) {
                          _vm.setor = $$v
                        },
                        expression: "setor"
                      }
                    },
                    _vm._l(_vm.setoresFluxo, function(setor) {
                      return _c("el-option", {
                        key: setor.acao,
                        attrs: { label: setor.nome, value: setor.acao }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.processo
        ? _c(
            "el-row",
            { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _vm.processo && this.isMaranhao()
                    ? _c(
                        "div",
                        { staticClass: "botao-processo" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.openModalNotificacao()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "center" }, [
                                _c("i", { staticClass: "fa fa-file icon" }),
                                _c("b", [_vm._v("  Modelo")])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "h4",
                    {
                      staticStyle: {
                        "margin-top": "10px",
                        "margin-bottom": "30px"
                      }
                    },
                    [_vm._v("Justificativa:")]
                  ),
                  !_vm.conversaAberta
                    ? _c("app-editor-texto", {
                        ref: "editorTexto",
                        staticClass: "input",
                        on: { onTextChange: _vm.onTextChange },
                        model: {
                          value: _vm.mensagem,
                          callback: function($$v) {
                            _vm.mensagem = $$v
                          },
                          expression: "mensagem"
                        }
                      })
                    : _vm._e(),
                  this.isAmapa()
                    ? [
                        _c("app-anexo", {
                          attrs: {
                            id: "upload-anexo-despacho",
                            files: _vm.dados.anexos,
                            showAnexar: _vm.verificaTamanho,
                            exibirDownload: false,
                            tipoExibir: "ANEXO_MANUTENCAO"
                          },
                          on: {
                            uploadFile: _vm.uploadFile,
                            removeFile: function($event) {
                              return _vm.removeDocumento($event)
                            }
                          }
                        })
                      ]
                    : _vm._e(),
                  _c("div", { staticClass: "botao-processo" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "button-mover",
                            attrs: {
                              type: "primary",
                              disabled: _vm.aguardandoDistribuicao
                            },
                            on: { click: _vm.moverProcesso }
                          },
                          [
                            _c("span", { staticClass: "center" }, [
                              _c("b", [_vm._v("Mover  ")]),
                              _c("i", { staticClass: "fas fa-chevron-right" })
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ],
                2
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.openModal
                    ? _c("app-modal-distribuicao", {
                        attrs: {
                          processo: _vm.processo,
                          mensagem: _vm.mensagemFormatada,
                          tarefa: _vm.tarefa,
                          dados: _vm.dados
                        },
                        on: {
                          closeModal: _vm.closeModal,
                          limparDados: _vm.limpar
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.showModalNotificacao
                    ? _c("app-modal-selecionar-modelo-notificacao", {
                        attrs: {
                          tiposModelo: _vm.tiposModelo,
                          titulo: "Modelos de Justificativa",
                          idProcesso: _vm.processo.id,
                          showModal: _vm.showModalNotificacao
                        },
                        on: {
                          closeModal: _vm.fecharModalNotificacao,
                          setTextoJustificativa: _vm.setTextoJustificativa
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16524f20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16524f20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/MovimentarProcessos.vue
// module id = null
// module chunks = 